import React, { useState, useEffect } from 'react';
import { QueryClient, QueryClientProvider } from 'react-query';
import BudgetStocksInFocus from '../../collection-templates/budget-stocks-in-focus';
import { useSelector } from 'react-redux';
import get from 'lodash/get';

export const StocksInFocusFullWidget = (props) => {
  const queryClient = new QueryClient;
  const [darkMode, setDarkMode] = useState(false);
  const [lightMode, setLightMode] = useState(false);
  const [client, setClient] = useState('');
  const blockedList = useSelector((state) =>
    get(state, ['qt', 'config', 'features', 'budget', 'clients', 'blocked_list'], [])
  );

  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const dm = urlParams.get('dm');
    const disabledm = urlParams.get('disabledm');
    const client = urlParams.get('client');

    if (dm === "1") {
      setDarkMode(true);
      setLightMode(false);
    } else if (disabledm === "1") {
      setDarkMode(false);
      setLightMode(true);
    } else {
      setDarkMode(false);
      setLightMode(false);
    }

    if (!!client) {
      setClient(client);
    }

    if (disabledm === "1") {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#FFFFFF";
    } else if (dm === "1" || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches)) {
      const body = document.getElementsByTagName('body')[0];
      body.style.backgroundColor = "#2B2B2B";
    }
  }, []);
  return (
    <QueryClientProvider client={queryClient}>
      {((!client) || (!!client && blockedList.indexOf(client.toLowerCase())) === -1) && (
        <BudgetStocksInFocus widget={true} count={4} darkMode={darkMode} lightMode={lightMode} client={client} {...props}/>
      )}
    </QueryClientProvider>
  );
};
